var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',{staticClass:"pt-10"},[_c('v-col',{attrs:{"cols":"12"}},[_c('h2',{attrs:{"data-cy":"intended-use-title"}},[_vm._v("Intended Use")]),_c('p',{attrs:{"data-cy":"intended-use"}},[_vm._v(" "+_vm._s(_vm.application.intended_use)+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }